import { SmallAddIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, SimpleGrid, SystemProps, SystemStyleObject, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { ReactNode } from 'react';

import EmptyTree from '@/assets/images/img_empty_status.png';
import NoResult from '@/assets/images/Img_no_result.png';

export enum ImageSize {
  NORMAL = 'normal',
  LARGE = 'large',
}

type ImageType = 'empty' | 'no-result';

type TableEmptyDataPlaceholderProps = {
  placeholderText: string;
  isCreateButtonVisible?: boolean;
  onButtonClick?: () => void;
  buttonText?: string;
  buttonTestId?: string;
  children?: ReactNode;
  extraButton?: ReactNode;
  emptyImageSize?: ImageSize;
  imageType?: ImageType;
  sx?: SystemStyleObject;
  gap?: SystemProps['gridGap'];
  exampleButton?: ReactNode;
};

const TableEmptyDataPlaceholder = (props: TableEmptyDataPlaceholderProps) => {
  const {
    placeholderText,
    isCreateButtonVisible,
    buttonText,
    onButtonClick,
    buttonTestId,
    extraButton,
    children,
    emptyImageSize = ImageSize.NORMAL,
    imageType,
    sx,
    gap = 2,
    exampleButton,
  } = props;

  const EMPTY_IMAGE_SIZE_MAPPING = {
    [ImageSize.NORMAL]: 80,
    [ImageSize.LARGE]: 160,
  };

  return (
    <SimpleGrid columns={1} textAlign={'center'} gap={gap} sx={sx}>
      <Box display='flex' justifyContent='center' alignContent={'center'}>
        <Image
          src={imageType === 'no-result' ? NoResult : EmptyTree}
          alt='Empty Image'
          width={EMPTY_IMAGE_SIZE_MAPPING?.[emptyImageSize] || 80}
        />
      </Box>
      {(placeholderText || exampleButton) && (
        <Box>
          {placeholderText && (
            <Text color='gray.600' fontSize='1rem' fontWeight={400} lineHeight={1.5} whiteSpace='pre-line'>
              {placeholderText}
            </Text>
          )}
          {exampleButton}
        </Box>
      )}
      {(extraButton || isCreateButtonVisible) && (
        <Flex margin='auto' gap={2}>
          {extraButton}
          {isCreateButtonVisible && (
            <Button
              data-testid={buttonTestId}
              leftIcon={<SmallAddIcon />}
              colorScheme='blue'
              size='lg'
              onClick={onButtonClick}
              width='fit-content'
            >
              {buttonText}
            </Button>
          )}
        </Flex>
      )}
      {children}
    </SimpleGrid>
  );
};

export default TableEmptyDataPlaceholder;
